// Helper function to create a new array of objects with stable unique IDs
export const createSkeletonCollection = (numItems: number, prefix: string) => {
  return Array.from({ length: numItems }, (_, index) => ({ id: `${prefix}-${index}` }));
};
